import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import Button from "../../components/Button"
import { AssessmentCard } from "../../components/assessment";
import { assessments } from "../../assets/data/assessments";
import Link from '@mui/material/Link';
import VisibilityIcon from '@mui/icons-material/Visibility';

export function Assessments() {
    const navigate = useNavigate();

    return (
        <Box>
             <Typography
                        align="left"
                        variant="h1"
                        color="primary.blue"
                        sx={{
                            margin: '0',
                            fontWeight: '700',
                            lineHeight: '1.5',
                            fontSize: '1.8rem',
                        }}>Assessments</Typography>
            <Grid container sx={{ mt: 2, width: '100%', ml: 0 }} spacing={4}>
                {assessments.map((e, i) => <AssessmentCard key={i} cardActions={
                     <Link
                     component="button"
                     variant="body2"
                     onClick={() => navigate(`/quiz/${e.assessmentId}`)}
                     title='View'
                     sx={{
                         background: 'tranaparent',
                         color: 'var(--mui-palette-primary-button)',
                         p: 0,
                     }}
                 >
                     <VisibilityIcon sx={{ color: 'var(--mui-palette-primary-orange)', fontSize: '26px'}} />
                 </Link>
                } assessment={e} />)}
            </Grid>
        </Box>
    )
}

const styles = {
    header: {
        textAlign: 'center',
        margin: '0',
        fontWeight: '500',
        lineHeight: '1.5'
    },
}